import { render, staticRenderFns } from "./PrefixInput.vue?vue&type=template&id=37a73bd0&scoped=true&"
import script from "./PrefixInput.vue?vue&type=script&lang=js&"
export * from "./PrefixInput.vue?vue&type=script&lang=js&"
import style0 from "./PrefixInput.vue?vue&type=style&index=0&id=37a73bd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a73bd0",
  null
  
)

export default component.exports